import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const HeaderBuyStep = () => {
    return (
        <div className="header-buy-step-wrapper">
            <div className="container d-flex justify-content-between align-items-center">
                <div className="sayman-logo">
                    <div className="d-none d-lg-block">
                    <Link to="/"><IconName name="sayman-logo" className="icon"/></Link>
                    </div>

                    <div className="d-block d-lg-none">
                        <Link to="/"><IconName name="logo" className="icon"/></Link>
                    </div>
                </div>
                <div className="user-info">
                    <ul className="nav">
                        <li className="nav-item cart-link position-relative">
                            <a href="#">
                                <IconName name="cart" className="icon"/>
                                <div className="number-cart position-absolute persian-number">1</div>
                            </a>
                        </li>
                        <li className="user">
                            <span className="name">وحید ناموری</span>
                            <img src="./assets/sample-image/vahid-namvari-gray copy.png" alt="user"/>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default HeaderBuyStep;
